import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { X, Beaker, ThumbsUp, ThumbsDown } from "lucide-react";

export default function DiscoveryLabPanel({ open, onClose }) {
  const [features, setFeatures] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/discovery-lab");
      setFeatures(data.features || []);
    } catch {}
  };

  useEffect(() => { if (open) load(); }, [open]);

  const vote = async (id, v) => {
    try {
      const current = features.find((f) => f.id === id);
      const newVote = current?.my_vote === v ? 0 : v;
      const { data } = await api.post("/discovery-lab/vote", { feature_id: id, vote: newVote });
      setFeatures((fs) => fs.map((f) => (f.id === id ? { ...f, my_vote: data.my_vote, up: data.up, down: data.down } : f)));
    } catch {}
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="lab-panel">
      <div className="bg-white border-hard shadow-hard-lg rounded-2xl w-full max-w-lg p-6 slide-up max-h-[85vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display text-2xl flex items-center gap-2"><Beaker strokeWidth={3} className="w-6 h-6" /> Keşif Laboratuvarı</h2>
          <button onClick={onClose} data-testid="lab-close-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn">
            <X strokeWidth={3} className="w-4 h-4" />
          </button>
        </div>
        <p className="text-sm text-[#555] mb-4">Bu haftaki deneysel özelliklere oy ver — en çok oy alanları geliştiriyoruz.</p>

        <div className="space-y-2">
          {features.map((f, i) => (
            <motion.div
              key={f.id}
              initial={{ opacity: 0, x: -6 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.04 }}
              className="border-hard-2 rounded-xl p-3 flex items-center gap-3"
              data-testid={`lab-feature-${f.id}`}
            >
              <div className="text-2xl">{f.emoji}</div>
              <div className="flex-1 min-w-0">
                <div className="font-black text-sm">{f.name}</div>
                <div className="text-xs text-[#555]">{f.desc}</div>
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => vote(f.id, 1)}
                  data-testid={`lab-vote-up-${f.id}`}
                  className={`flex items-center gap-1 border-hard-2 rounded-full px-2 py-1 press-btn text-xs font-black ${f.my_vote === 1 ? "bg-[#CCFF00]" : "bg-white"}`}
                >
                  <ThumbsUp strokeWidth={3} className="w-3.5 h-3.5" /> {f.up}
                </button>
                <button
                  onClick={() => vote(f.id, -1)}
                  data-testid={`lab-vote-down-${f.id}`}
                  className={`flex items-center gap-1 border-hard-2 rounded-full px-2 py-1 press-btn text-xs font-black ${f.my_vote === -1 ? "bg-[#FF9E80]" : "bg-white"}`}
                >
                  <ThumbsDown strokeWidth={3} className="w-3.5 h-3.5" /> {f.down}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
